import { SVG, SVGProps } from '../../../main/components/icon/svg'

export function Divider({ width = 5, height = 6, ...props }: SVGProps) {
  return (
    <SVG {...props} width={width} height={height} viewBox="0 0 5 6">
      <path d="M5 6 1.4 3.9a1 1 0 0 1 0-1.8L5 0v6Z" />
    </SVG>
  )
}
